import * as React from 'react';
import logo from '../../assets/imgs/logo.png';
import LoginApi from "../../api/login";
import { toast } from 'react-toastify';

export default class Login extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            email: "",
            password: ""
        }
    }

    login(){
        LoginApi.login(this.state.email, this.state.password).then(res => {
            if(res.data.response.rol=="jugador"){
                toast.error("Error, usuario inválido");
                return;
            }
            localStorage.setItem('token', res.data.response.token);
            localStorage.setItem('rol', res.data.response.rol);
            localStorage.setItem('id', res.data.response.id);
            window.location.reload();
        }).catch(err => console.log(err));
    }

    render(){
        return (
            <div className="columns">
                <div className="column is-3"/>
                <div className="column is-6">
                    <div className="card">
                        <div className="card-content">
                            <div className="has-text-centered">
                                <img src={logo} alt="Futstuff" />
                            </div>
                            <br/>
                            <div className="FieldHorizontal field is-horizontal">
                                <div className="field-label">
                                    <label className="label">Correo</label>
                                </div>
                                <div className="field-body">
                                    <input
                                        className="input"
                                        type={'email'}
                                        value={this.state.email}
                                        onChange={(e) => {
                                            let state = {...this.state};
                                            state.email = e.currentTarget.value;
                                            this.setState(state);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="FieldHorizontal field is-horizontal">
                                <div className="field-label">
                                    <label className="label">Contraseña</label>
                                </div>
                                <div className="field-body">
                                    <input
                                        className="input"
                                        type={'password'}
                                        value={this.state.password}
                                        onChange={(e) => {
                                            let state = {...this.state};
                                            state.password = e.currentTarget.value;
                                            this.setState(state);
                                        }}
                                    />
                                </div>
                            </div>
                            <button
                                className="is-success button"
                                disabled={!this.state.password || !this.state.email}
                                onClick={() => this.login()}
                            >
                                Iniciar sesión
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/login/Login.js